const tech = [
    {
        "title": "C++",
        "imageSrc": "/cpp.png"
    },
    {
        "title": "Java",
        "imageSrc": "/java.png"
    },
    {
        "title": "Python",
        "imageSrc": "/python.png"
    },
    {
        "title": "HTML",
        "imageSrc": "/html.png"
    },
    {
        "title": "CSS",
        "imageSrc": "/css.png"
    },
    {
        "title": "Javascript",
        "imageSrc": "/javascript.png"
    },
    {
        "title": "Node js",
        "imageSrc": "/node.png"
    },
    {
        "title": "Express",
        "imageSrc": "/express.png"
    },
    {
        "title": "React js",
        "imageSrc": "/react.png"
    },
    {
        "title": "Flutter",
        "imageSrc": "/flutter.png"
    },
    {
        "title": "RestApi",
        "imageSrc": "/api.png"
    },
    {
        "title": "Solidity",
        "imageSrc": "/solidity.png"
    },
    {
        "title": "MongoDB",
        "imageSrc": "/mongo.png"
    },
    {
        "title": "Git",
        "imageSrc": "/git.png"
    }
];

export default tech;
